import { render, staticRenderFns } from "./ClaimNote.vue?vue&type=template&id=8f5942a0&"
import script from "./ClaimNote.vue?vue&type=script&lang=js&"
export * from "./ClaimNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports